<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <template>
        <v-layout>
          <v-flex xs12 sm6 md3>
            <!-- <v-btn color="primary" dark  @click="dialog = true; added_items = [] ">إضافة فاتورة تحويل لمخزن </v-btn> -->
          </v-flex>

          <v-flex xs12 sm6 md4>
            <v-autocomplete
              outline
              v-model="change_store_from"
              :items="stores_of"
              item-text="name"
              item-value="name"
              label="فواتير مخزن من  "
              persistent-hint
              return-object
              single-line
              @change="get_store_from"
              v-validate="'required'"
              :error-messages="errors.collect('form1.manger')"
              data-vv-name="manger"
              data-vv-scope="form1"
            >
              <template v-slot:append-outer>
                <v-slide-x-reverse-transition mode="out-in">
                </v-slide-x-reverse-transition>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </template>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="orange">
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>اغلاق</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="dialog = false">حفظ</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-toolbar color="orange">
              <v-toolbar-title>إضافة فاتورة تحويل لمخزن </v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              فاتورة تحويل لمخزن جديدة
              <!-- <v-btn color="blue">فاتورة جديدة</v-btn> -->
              <!-- <v-btn color="blue">فاتورة قديمة</v-btn> -->
              <!-- <v-flex xs12 sm6 md3>
            <v-text-field height=10 outline @keyup.enter="search_client_by_code" v-model="client_search_name" label="كود العميل" ></v-text-field>
        </v-flex> -->
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-form ref="form">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                          height="10"
                          outline
                          disabled
                          v-model="mycode"
                          label="كود الفاتورة"
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.code')"
                          data-vv-name="code"
                          data-vv-scope="form1"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <v-autocomplete
                          outline
                          v-model="select_store_from"
                          :items="stores_of"
                          item-text="name"
                          item-value="name"
                          label="مخزن من  "
                          persistent-hint
                          return-object
                          single-line
                          @change="change_store_from_to_get_items"
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form1"
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-autocomplete
                          outline
                          v-model="select_store_to"
                          :items="stores_of"
                          item-text="name"
                          item-value="name"
                          label="  مخزن الي"
                          persistent-hint
                          return-object
                          single-line
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form1"
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field
                          outline
                          disabled
                          v-model="asnaf_q"
                          label="   عدد الاصناف   "
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.num_asnaf')"
                          data-vv-name="num_asnaf"
                          data-vv-scope="form1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-dialog
                          ref="dialog2"
                          v-model="modal2"
                          :return-value.sync="date2"
                          persistent
                          lazy
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="date2"
                              label=" التاريخ اليدوي"
                              readonly
                              outline
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date2" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal2 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              flat
                              color="primary"
                              @click="$refs.dialog2.save(date2)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>

                      <v-flex xs12 sm6 md3>
                        <v-autocomplete
                          v-model="select_item"
                          :items="m_items"
                          item-text="name"
                          item-value="id"
                          label="أختر الصنف"
                          persistent-hint
                          return-object
                          single-line
                          v-validate="'required'"
                          :error-messages="errors.collect('form1.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form1"
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-btn @click="add_item">add</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-divider class=" my-1" inset horizontal></v-divider>
                    <v-divider class=" my-1" inset horizontal></v-divider>
                    <v-data-table
                      :headers="headers2"
                      :items="added_items"
                      class="elevation-1"
                      :search="search"
                      :loading="loading"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="items" slot-scope="props">
                        <td>
                          <v-btn
                            style="width: 50px;"
                            @click="remove_item(props.item)"
                            ><v-icon>delete</v-icon></v-btn
                          >
                        </td>
                        <td
                          :style="{ 'background-color': props.item.item_color }"
                        >
                          {{ props.item.item_name }}
                        </td>
                        <td
                          :style="[
                            props.item.quantity <= 10
                              ? { 'background-color': 'red' }
                              : { 'background-color': 'yellow' }
                          ]"
                        >
                          {{ props.item.quantity }}
                        </td>
                        <td>
                          <input
                            style="width: 100%;"
                            type="number"
                            v-model="props.item.item_num"
                            min="1"
                            :max="props.item.quantity"
                            @change="check_max(props.item, props.item.quantity)"
                          />
                        </td>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
                <v-btn color="blue darken-1" flat @click="save('form1')"
                  >حفظ</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-list>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog2"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="orange">
            <v-btn icon dark @click="dialog2 = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>اغلاق</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="dialog2 = false">حفظ</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-toolbar color="orange">
              <v-toolbar-title>تعديل فاتورة تحويل لمخزن </v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              فاتورة تحويل لمخزن
              <!-- <v-btn color="blue">فاتورة جديدة</v-btn> -->
              <!-- <v-btn color="blue">فاتورة قديمة</v-btn> -->
              <!-- <v-flex xs12 sm6 md3>
            <v-text-field height=10 outline @keyup.enter="search_client_by_code" v-model="client_search_name" label="كود العميل" ></v-text-field>
        </v-flex> -->
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-form ref="form">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                          height="10"
                          outline
                          disabled
                          v-model="editItem.code"
                          label="كود الفاتورة"
                          v-validate="'required'"
                          :error-messages="errors.collect('form2.code')"
                          data-vv-name="code"
                          data-vv-scope="form2"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md3>
                        <v-autocomplete
                          outline
                          v-model="select_store_from_edit"
                          :items="stores_of"
                          item-text="name"
                          item-value="name"
                          label="مخزن من  "
                          persistent-hint
                          return-object
                          single-line
                          v-validate="'required'"
                          :error-messages="errors.collect('form2.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form2"
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-autocomplete
                          outline
                          v-model="select_store_to_edit"
                          :items="stores_of"
                          item-text="name"
                          item-value="name"
                          label="  مخزن الي"
                          persistent-hint
                          return-object
                          single-line
                          v-validate="'required'"
                          :error-messages="errors.collect('form2.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form2"
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                          outline
                          disabled
                          v-model="asnaf_q"
                          label="   عدد الاصناف   "
                          v-validate="'required'"
                          :error-messages="errors.collect('form2.num_asnaf')"
                          data-vv-name="num_asnaf"
                          data-vv-scope="form2"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md3>
                        <v-autocomplete
                          v-model="select_item"
                          :items="m_items"
                          item-text="name"
                          item-value="id"
                          label="أختر الصنف"
                          persistent-hint
                          return-object
                          single-line
                          v-validate="'required'"
                          :error-messages="errors.collect('form2.manger')"
                          data-vv-name="manger"
                          data-vv-scope="form2"
                        >
                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition mode="out-in">
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-btn @click="add_item">add</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-divider class=" my-1" inset horizontal></v-divider>
                    <v-divider class=" my-1" inset horizontal></v-divider>
                    <v-data-table
                      :headers="headers2"
                      :items="added_items"
                      class="elevation-1"
                      :loading="loading"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="items" slot-scope="props">
                        <td>
                          <v-btn
                            style="width: 50px;"
                            @click="remove_item(props.item)"
                            ><v-icon>delete</v-icon></v-btn
                          >
                        </td>
                        <td
                          :style="{ 'background-color': props.item.item_color }"
                        >
                          {{ props.item.item_name }}
                        </td>
                        <td
                          :style="[
                            props.item.store_item.quantity <= 10
                              ? { 'background-color': 'red' }
                              : { 'background-color': 'yellow' }
                          ]"
                        >
                          {{ props.item.store_item.quantity }}
                        </td>
                        <td>
                          <input
                            style="width: 100%;"
                            type="number"
                            v-model="props.item.item_num"
                            min="0"
                            :max="props.item.store_item.quantity"
                            @change="
                              check_max(
                                props.item,
                                props.item.store_item.quantity
                              )
                            "
                          />
                        </td>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
                <v-btn color="blue darken-1" flat @click="update('form2')"
                  >تعديل</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-list>
        </v-card>
      </v-dialog>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.store_name_from }}</td>
            <td class="text-xs-right">{{ props.item.store_name_to }}</td>
            <td class="text-xs-right">{{ props.item.num_asnaf }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="justify-center layout px-0">
              <v-dialog
                v-model="detail_dialog"
                width="800"
                dark
                style="padding:10px"
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    class="ml-4"
                    v-on="on"
                    @click="detailItem(props.item)"
                  >
                    book
                  </v-icon>
                </template>

                <v-card>
                  <v-card-title class="headline orange lighten-2" primary-title>
                    تفاصيل فاتورة التحويل
                  </v-card-title>

                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md4>
                        الكود :
                        {{ item_detail.code }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        مخزن من :
                        {{ item_detail.store_name_from }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        مخزن الي :
                        {{ item_detail.store_name_to }}
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        عدد الاصناف :
                        {{ item_detail.num_asnaf }}
                      </v-flex>
                    </v-layout>
                    <hr />
                    <v-data-table
                      :headers="headers3"
                      :items="item_detail.items"
                      class="elevation-1"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.item_name }}</td>
                        <td>{{ props.item.item_num }}</td>
                      </template>
                    </v-data-table>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="detail_dialog = false">
                      موافق
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </td>
            <td v-if="permissions.delete_all == 1 || user.type == 1">
              <v-icon
                v-if="!is_store_to"
                color="primary"
                dark
                @click="edit_fatwora(props.item)"
              >
                edit
              </v-icon>
            </td>
            <td v-if="permissions.delete_all == 1 || user.type == 1">
              <v-icon
                v-if="!is_store_to"
                color="danger"
                dark
                @click="delete_fatwora(props.item)"
              >
                delete
              </v-icon>
            </td>
            <td>
              <p v-if="!is_store_to">{{ props.item.notes }}</p>
              <textarea
                v-model="props.item.notes"
                v-if="is_store_to"
              ></textarea>
            </td>
            <td style="padding:0px">
              <v-btn
                v-if="is_store_to"
                color="orange"
                small
                @click.prevent="transfer_confirm2(props.item)"
              >
                <!-- @click="confirm_fatwora" -->
                تاكيد التحويل
              </v-btn>
              <v-btn
                v-if="is_store_to"
                color="red"
                small
                @click.prevent="transfer_reject(props.item)"
              >
                <!-- @click="confirm_fatwora" -->
                رفض التحويل
              </v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  all_transfer_fatworas,
  fatworas_transfer_from,
  fatworas_transfer_to,
  transfer_confirm,
  transfer_reject,
  fatwora,
  add_fatwora_transfer,
  update_fatwora_transfer,
  items_of,
  stores_of,
  delete_transfer_fatwora,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,
    dialog2: false,
    rowsPerPageItems: [400, 800],
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    item_detail: {},
    detail_dialog: false,

    select_item: { id: "", job_name: "", name: "أختر الصنف" },
    select_store_from: { id: "" },
    select_store_to: { id: "" },
    select_store_from_edit: { id: "" },
    select_store_to_edit: { id: "" },
    change_store_from: { id: "" },
    change_store_to: { id: "" },
    is_store_to: false,

    search: "",
    loading: false,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "مخزن من ", value: "store_name_from", align: "right" },
      { text: "  مخزن الي", value: "store_name_to", align: "right" },
      { text: "   عدد الاصناف", value: "taslim_date", align: "right" },
      { text: " التاريخ", value: "taslim_date", align: "right" },
      { text: " تفاصيل", value: "store", sortable: false, align: "right" },
      { text: " تعديل", value: "store", sortable: false, align: "right" },
      { text: " حذف", value: "store", sortable: false, align: "right" },
      {
        text: "اكتب سبب الرفض  ",
        value: "store",
        sortable: false,
        align: "right"
      },
      { text: " تأكيد", value: "store", sortable: false, align: "right" }
    ],
    headers2: [
      {
        text: "حذف ",
        align: "right",
        value: "حذف"
      },
      {
        text: " اسم الصنف",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      {
        text: "الكمية المتاحة",
        value: "item_num",
        sortable: false,
        align: "right"
      },
      { text: " العدد", value: "item_num", sortable: false, align: "right" }
    ],

    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "item_num", sortable: false, align: "right" }
    ],

    fatworas: [],
    all_fatworas: [],
    m_sadad_types: [],
    m_employers: [],
    clients: [],
    m_items: [],
    stores_of: [],
    client_search_name: "",
    stores_of: [],
    newItem: {
      id: "",
      code: "",
      emp_name_store_from: "",
      emp_name_store_to: "",
      store_name_from: "",
      store_name_to: "",
      num_asnaf: "",
      notes: "",
      store_id_from: "",
      store_id_to: "",
      created_at: ""
    },
    editItem: {},
    added_items: [],
    modal2: false,
    date2: new Date().toISOString().substr(0, 10)
  }),

  computed: {
    mycode() {
      if (this.all_fatworas.length > 0) {
        return (this.code =
          parseInt(this.all_fatworas[this.all_fatworas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    asnaf_q() {
      return this.added_items.length;
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    stores_of().then(response => {
      this.stores_of = response.data.stores;
    });

    all_transfer_fatworas().then(response => {
      this.all_fatworas = response.data;
    });
  },

  methods: {
    check_max(item, q) {
      let index = this.added_items.indexOf(item);
      if (parseInt(item.item_num) > parseInt(q)) {
        alert("لا يجوز ادخال قيمة اكبر من العدد المتاح");
        this.added_items[index].item_num = q;
      }
      if (parseInt(item.item_num) < 0) {
        alert("لا يجوز ادخال قيمة اقل من الصفر ");
      }
    },
    initialize() {},

    edit_fatwora(item) {
      this.editItem = item;
      this.select_store_from_edit = item.store_from;
      this.select_store_to_edit = item.store_to;
      this.added_items = item.items;
      this.dialog2 = true;
      this.select_store_from = item.store_from;
      this.change_store_from_to_get_items();
    },

    add_item() {
      this.added_items.push({
        item_name: this.select_item.name,
        item_color: this.select_item.item_color,
        quantity: this.select_item.store_item.quantity,
        item_num: 1,
        item_id: this.select_item.id
      });
      this.select_item = { id: "" };
    },
    remove_item(item) {
      const index = this.added_items.indexOf(item);
      this.added_items.splice(index, 1);
    },
    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.fatworas.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_fatwora(frmData2, item.id).then(response => {
            this.loading = false;
            this.fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    },
    delete_fatwora(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.fatworas.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_transfer_fatwora(frmData2, item.id).then(response => {
            this.loading = false;
            this.fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.code = this.code;
          this.newItem.emp_name_store_from = myUser.name;
          this.newItem.store_name_from = this.select_store_from.name;
          this.newItem.store_name_to = this.select_store_to.name;
          this.newItem.num_asnaf = this.added_items.length;
          this.newItem.notes = this.newItem.notes;
          this.newItem.store_id_from = this.select_store_from.id;
          this.newItem.store_id_to = this.select_store_to.id;
          this.newItem.created_at = this.date2;

          var frmData = new FormData();
          frmData.append("transfer_fatwora", JSON.stringify(this.newItem));
          frmData.append("fatwora_items", JSON.stringify(this.added_items));

          add_fatwora_transfer(frmData).then(response => {
            Object.assign(this.$data.newItem, this.$options.data().newItem);
            this.fatworas.push(response.data);
            this.loading = false;
            this.close();
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    },
    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let id = this.editItem.id;
          this.editItem.store_name_from = this.select_store_from_edit.name;
          this.editItem.store_name_to = this.select_store_to_edit.name;
          this.editItem.num_asnaf = this.added_items.length;
          this.editItem.notes = "تم التعديل";
          this.editItem.store_id_from = this.select_store_from_edit.id;
          this.editItem.store_id_to = this.select_store_to_edit.id;

          var frmData = new FormData();
          frmData.append("transfer_fatwora", JSON.stringify(this.editItem));
          frmData.append("fatwora_items", JSON.stringify(this.added_items));

          update_fatwora_transfer(id, frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            this.loading = false;
            this.close();
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    },
    get_store_from() {
      this.loading = true;
      fatworas_transfer_from(this.change_store_from.id).then(response => {
        this.fatworas = response.data;
        this.pagination.totalItems = response.data.length;
        this.loading = false;
        this.is_store_to = false;
        this.change_store_to = { id: "" };
      });
    },
    get_store_to() {
      this.loading = true;
      fatworas_transfer_to(this.change_store_to.id).then(response => {
        this.fatworas = response.data;
        this.pagination.totalItems = response.data.length;
        this.loading = false;
        this.is_store_to = true;
        this.change_store_from = { id: "" };
      });
    },

    change_store_from_to_get_items() {
      items_of(this.select_store_from.id).then(response => {
        this.m_items = response.data;
      });
    },

    transfer_confirm2(item) {
      var frmData = new FormData();
      let myUser = JSON.parse(localStorage.getItem("user"));
      frmData.append("emp_name_store_to", myUser.name);
      this.loading = true;
      transfer_confirm(item.id, frmData).then(response => {
        this.loading = false;
        const index = this.fatworas.indexOf(item);
        this.fatworas.splice(index, 1);
      });
    },
    transfer_reject(item) {
      if (item.notes == "") {
        alert("من فضلك وضح سبب الرفض في الجزء المخصص");
      } else {
        var frmData = new FormData();
        frmData.append("notes", item.notes);
        this.loading = true;
        transfer_reject(item.id, frmData).then(response => {
          this.loading = false;
          const index = this.fatworas.indexOf(item);
          this.fatworas.splice(index, 1);
        });
      }
    },

    detailItem(order) {
      this.item_detail = order;
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
</style>
